<template>
  <v-card class="pa-4 mb-4">
    <v-card-title>Analisi per luogo di prenotazione</v-card-title>
    <v-card-text>
      <v-row>
        <v-col cols="12">
          <l-map
              style="height: 600px; width: 100%"
              :zoom="zoom"
              :center="mapCenter"
              :options="{ scrollWheelZoom: false }"
          >
            <l-tile-layer
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                attribution="&copy; OpenStreetMap contributors"
            />

            <!-- Cluster wrapper -->
            <l-marker-cluster :options="clusterOptions">
              <l-marker
                  v-for="(marker, index) in markers"
                  :key="index"
                  :lat-lng="[marker.coordinates[1], marker.coordinates[0]]"
                  :icon="generateMarkerIcon(marker.count)"
              >
                <l-popup>
                  <strong>{{ marker.name }}</strong><br />
                  Prenotazioni: {{ marker.count }}
                </l-popup>
              </l-marker>
            </l-marker-cluster>
          </l-map>

        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>


<script>
import { LMap, LTileLayer, LMarker, LPopup } from 'vue2-leaflet';
import LMarkerCluster from 'vue2-leaflet-markercluster';
import 'leaflet/dist/leaflet.css';
import 'leaflet.markercluster/dist/MarkerCluster.css';
import 'leaflet.markercluster/dist/MarkerCluster.Default.css';
import { generateMarkerIcon } from '@/utils/markerIconGenerator';

export default {
  name: 'ReservationByGeo',
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
    LMarkerCluster
  },
  props: {
    filters: Object
  },
  data() {
    return {
      result: [],
      clusterOptions: {
        showCoverageOnHover: false,
        spiderfyOnMaxZoom: true,
        disableClusteringAtZoom: 15,
        maxClusterRadius: 50
      },
      markers: [],
      mapCenter: [42.5, 13.5],
      zoom: 6
    };
  },
  watch: {
    filters: {
      deep: true,
      immediate: true,
      handler(newFilters) {
        this.fetchData(newFilters);
      }
    }
  },
  methods: {
    generateMarkerIcon,
    async fetchData(filters) {
      const data = await this.$store.dispatch('analytics/getReservationsByGeo', filters);
      this.result = data;
      this.markers = data;
    }
  }
};
</script>
